var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 901,
    height: 943,
    viewBox: "0 0 901 943",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99,
    filter: "url(#filter0_f_531_109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.344 112.325L486.609 106.841C396.556 86.8744 302.416 111.908 234.176 173.968C218.442 188.277 204.366 204.31 192.212 221.763L188.644 226.888C159.266 269.077 139.86 317.391 131.893 368.18L103.854 546.929C89.1754 640.507 127.352 734.544 203.107 791.409C250.558 827.027 308.905 845.063 368.179 842.435L580.891 833.003C595.919 832.336 610.831 830.043 625.366 826.163C681.835 811.087 729.367 772.967 756.345 721.119L758.773 716.452C771.478 692.034 779.491 665.45 782.396 638.078L798.914 482.408C804.55 429.302 796.9 375.629 776.652 326.213C750.262 261.806 703.729 207.675 644.014 171.915L610.272 151.71C579.624 133.356 546.22 120.058 511.344 112.325Z",
    fill: "url(#paint0_linear_531_109)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_531_109",
    x: 0.754761,
    y: 0.107422,
    width: 899.959,
    height: 942.578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_531_109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_531_109",
    x1: 687.5,
    y1: 75,
    x2: 444,
    y2: 747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00417E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.a5f339ad50e5b42487e24079035c0da7.svg";
export { ForwardRef as ReactComponent };